<div style="width: 100%; text-align: center;">
    <div class="contentContainer">
        <div class="titlebar">
            <span class="text"> PROPERTY SMART CARD:</span><span class="number"> {{propertyNumber}}</span><br>
            <span class="text"> </span><span (click)="toggleBearerDetails()" class="number" style="cursor: pointer;"> {{bearerName}}</span>
            <div [hidden]="showBearerDetails">
                <span class="text"> </span><span class="number"> {{bearerEmail}}</span><br>
                <span class="text"> </span><span class="number"> {{bearerMobile}}</span>
            </div>

        </div>
        <ul>
            <li class="dashboard-button">
                <img src="../../assets/dashboard/btnOwnershipDetails.png" alt="Ownership details"
                    onmouseover="this.src='../../assets/dashboard/btnOwnershipDetails_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnOwnershipDetails.png'" (click)="onOwnershipSummary()">
            </li>
            <li>
                <img src="../../assets/dashboard/btnPropertyDetails.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnPropertyDetails_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnPropertyDetails.png'" (click)="onPropertyDetails()">
            </li>


            <li>
                <img src="../../assets/dashboard/btnPropertyPhotos.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnPropertyPhotos_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnPropertyPhotos.png'" (click)="onPropertyPhotos()">
            </li>
            <li>
                <img src="../../assets/dashboard/btnPropertyDocuments.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnPropertyDocuments_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnPropertyDocuments.png'" (click)="onPropertyDocuments()">
            </li>
        </ul>

        <ul>
            <li>
                <img src="../../assets/dashboard/changepin.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/changepin_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/changepin.png'" (click)="onPinChange()">
            </li>
            <li>
                <img src="../../assets/dashboard/btnUpdateDocuments.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnUpdateDocuments_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnUpdateDocuments.png'"  (click)="onUpdateDocuments()">
            </li>
            <li>
                <img src="../../assets/dashboard/btnBlockCard.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnBlockCard_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnBlockCard.png'" (click)="onBlockCard()">
            </li>
            <li>
                <img src="../../assets/dashboard/btnCustomerCare.png" alt="Customer care"
                    onmouseover="this.src='../../assets/dashboard/btnCustomerCare_hover.png'"
                    onmouseout="this.src='../../assets/dashboard/btnCustomerCare.png'" (click)="onCustomerCare()">
            </li>
        </ul>
        <input type="button" value="LOGOUT" style="width: 310px; height: 40px; border: none;" class="titlebar logoutbtn" (click)="onLogoutClicked()">
    </div>

</div>